import { ImpulseElement, property, registerElement, target } from '@ambiki/impulse';
import axios from 'axios';

/**
 *
 * This component allows a checkbox component to make an ajax request to our API
 * without having to submit the form and reload the page.
 *
 */
@registerElement('ajax-checkbox')
export default class AjaxCheckboxElement extends ImpulseElement {
  /**
   * The endpoint to send the request too.
   */
  @property() src: string;

  /**
   * The boolean status of the checkbox.
   */
  @property({ type: Boolean }) status = false;

  /**
   * The request body, as a JSON object.
   */
  @property({ type: Object }) data: Record<string, unknown> = {};

  /**
   * A boolean indicator that notifies the JS if the value must be revoked
   * or just toggled off
   */
  @property({ type: Boolean }) revokeStatus = false;

  /**
   * The HTML error field.
   */
  @target() error: HTMLElement;

  /**
   * The HTML checkbox element.
   */
  @target() checkbox: HTMLElement;

  /**
   * The HTML parent element.
   *
   */
  @target() parentRow: HTMLElement;

  /**
   *
   * Performs the related API call and adjusted the DOM as necessary.
   *
   * @function checkboxClicked
   * @return null
   */
  async checkboxClicked() {
    if (!(this.checkbox instanceof HTMLInputElement)) return;

    this.parentRow.classList.add('saving');

    try {
      const { status, data } = await axios.post(this.src, this.data);
      if (status === 200) {
        this.checkbox.checked = data.on;
        this.status = data.on;
        if (this.revokeStatus) {
          this.parentRow.classList.toggle('revoked', !data.on);
        }
      } else {
        this.error.textContent = 'Something went wrong. Please try again later.';
      }

      this.parentRow.classList.remove('saving');
    } catch (error) {
      this.error.textContent = 'Something went wrong. Please try again later.';
      this.parentRow.classList.remove('saving');
    }
  }
}
